import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getPosts } from '../api/posts';
import PostCard from '../components/PostCard';

const Home = () => {
    const [posts, setPosts] = useState([]);

    useEffect(() => {
        getPosts().then(setPosts).catch(console.error);
    }, []);

    return (
        <div>
            <div className="page-header">
                <h1>Recent Posts</h1>
                <Link to="/new" className="btn btn-primary">Create New Post</Link>
            </div>
            <div className="post-grid">
                {posts.map((post) => (
                    <PostCard key={post.id} post={post} />
                ))}
            </div>
        </div>
    );
};

export default Home;
